var map = {
	"./blocks/contextMenu/contextMenu": [
		6383,
		8764
	],
	"./blocks/contextMenu/contextMenu.js": [
		6383,
		8764
	],
	"./blocks/features/features": [
		2183,
		2183
	],
	"./blocks/features/features.js": [
		2183,
		2183
	],
	"./blocks/header/header": [
		8639,
		2483,
		8639
	],
	"./blocks/header/header.js": [
		8639,
		2483,
		8639
	],
	"./blocks/meta/meta": [
		1615,
		6807,
		1615
	],
	"./blocks/meta/meta.js": [
		1615,
		6807,
		1615
	],
	"./blocks/spinner": [
		9970,
		2724,
		4285
	],
	"./blocks/spinner/": [
		9970,
		2724,
		4285
	],
	"./blocks/spinner/index": [
		9970,
		2724,
		4285
	],
	"./blocks/spinner/index.js": [
		9970,
		2724,
		4285
	],
	"./layout/footer/footer": [
		1683,
		1683
	],
	"./layout/footer/footer.js": [
		1683,
		1683
	],
	"./layout/navbar/navbar": [
		4273,
		2115,
		6190
	],
	"./layout/navbar/navbar.js": [
		4273,
		2115,
		6190
	],
	"./layout/scrollToTop": [
		1652
	],
	"./layout/scrollToTop/": [
		1652
	],
	"./layout/scrollToTop/index": [
		1652
	],
	"./layout/scrollToTop/index.js": [
		1652
	],
	"./modals/addHighlighted/addHighlighted": [
		9133,
		1222,
		9133
	],
	"./modals/addHighlighted/addHighlighted.js": [
		9133,
		1222,
		9133
	],
	"./modals/addSet/addSet": [
		3659,
		3659
	],
	"./modals/addSet/addSet.js": [
		3659,
		3659
	],
	"./modals/addSetGenerate": [
		2803,
		2803
	],
	"./modals/addSetGenerate/": [
		2803,
		2803
	],
	"./modals/addSetGenerate/index": [
		2803,
		2803
	],
	"./modals/addSetGenerate/index.js": [
		2803,
		2803
	],
	"./modals/addTopic/addTopic": [
		361,
		361
	],
	"./modals/addTopic/addTopic.js": [
		361,
		361
	],
	"./modals/flashcard/flashcard": [
		3343,
		5724
	],
	"./modals/flashcard/flashcard.js": [
		3343,
		5724
	],
	"./modals/modal/modal": [
		9319,
		9319
	],
	"./modals/modal/modal.js": [
		9319,
		9319
	],
	"./modals/settings/settings": [
		5763,
		5763
	],
	"./modals/settings/settings.js": [
		5763,
		5763
	],
	"./pages/404/Index": [
		741,
		741
	],
	"./pages/404/Index.js": [
		741,
		741
	],
	"./pages/exercises/exerciseTense/Index": [
		1776,
		2483,
		6807,
		1222,
		2724,
		116,
		1776
	],
	"./pages/exercises/exerciseTense/Index.js": [
		1776,
		2483,
		6807,
		1222,
		2724,
		116,
		1776
	],
	"./pages/exercises/exerciseTense/actionButtonsBottom": [
		9281,
		2724,
		9054
	],
	"./pages/exercises/exerciseTense/actionButtonsBottom/": [
		9281,
		2724,
		9054
	],
	"./pages/exercises/exerciseTense/actionButtonsBottom/index": [
		9281,
		2724,
		9054
	],
	"./pages/exercises/exerciseTense/actionButtonsBottom/index.jsx": [
		9281,
		2724,
		9054
	],
	"./pages/exercises/exerciseTense/listOfSentences": [
		5550,
		116,
		5550
	],
	"./pages/exercises/exerciseTense/listOfSentences/": [
		5550,
		116,
		5550
	],
	"./pages/exercises/exerciseTense/listOfSentences/index": [
		5550,
		116,
		5550
	],
	"./pages/exercises/exerciseTense/listOfSentences/index.jsx": [
		5550,
		116,
		5550
	],
	"./pages/exercises/list/Index": [
		6991,
		2483,
		6807,
		6991
	],
	"./pages/exercises/list/Index.js": [
		6991,
		2483,
		6807,
		6991
	],
	"./pages/flashcards/learn": [
		3699,
		2483,
		6807,
		116,
		3699
	],
	"./pages/flashcards/learn/": [
		3699,
		2483,
		6807,
		116,
		3699
	],
	"./pages/flashcards/learn/cardBtn/cardBtn": [
		7848,
		7848
	],
	"./pages/flashcards/learn/cardBtn/cardBtn.js": [
		7848,
		7848
	],
	"./pages/flashcards/learn/cardView/cardView": [
		6572,
		6572
	],
	"./pages/flashcards/learn/cardView/cardView.js": [
		6572,
		6572
	],
	"./pages/flashcards/learn/index": [
		3699,
		2483,
		6807,
		116,
		3699
	],
	"./pages/flashcards/learn/index.js": [
		3699,
		2483,
		6807,
		116,
		3699
	],
	"./pages/flashcards/learn/result/result": [
		4208,
		4208
	],
	"./pages/flashcards/learn/result/result.js": [
		4208,
		4208
	],
	"./pages/flashcards/learn/settingsBtn/settingsBtn": [
		3372,
		3372
	],
	"./pages/flashcards/learn/settingsBtn/settingsBtn.js": [
		3372,
		3372
	],
	"./pages/flashcards/listOfSets": [
		6995,
		2483,
		6807,
		1222,
		2724,
		116,
		6995
	],
	"./pages/flashcards/listOfSets/": [
		6995,
		2483,
		6807,
		1222,
		2724,
		116,
		6995
	],
	"./pages/flashcards/listOfSets/actionBtn": [
		8642,
		8642
	],
	"./pages/flashcards/listOfSets/actionBtn/": [
		8642,
		8642
	],
	"./pages/flashcards/listOfSets/actionBtn/index": [
		8642,
		8642
	],
	"./pages/flashcards/listOfSets/actionBtn/index.js": [
		8642,
		8642
	],
	"./pages/flashcards/listOfSets/index": [
		6995,
		2483,
		6807,
		1222,
		2724,
		116,
		6995
	],
	"./pages/flashcards/listOfSets/index.js": [
		6995,
		2483,
		6807,
		1222,
		2724,
		116,
		6995
	],
	"./pages/flashcards/listOfSets/list": [
		1312,
		2483,
		1312
	],
	"./pages/flashcards/listOfSets/list/": [
		1312,
		2483,
		1312
	],
	"./pages/flashcards/listOfSets/list/index": [
		1312,
		2483,
		1312
	],
	"./pages/flashcards/listOfSets/list/index.js": [
		1312,
		2483,
		1312
	],
	"./pages/flashcards/listOfValues": [
		7748,
		2483,
		6807,
		1222,
		116,
		7748
	],
	"./pages/flashcards/listOfValues/": [
		7748,
		2483,
		6807,
		1222,
		116,
		7748
	],
	"./pages/flashcards/listOfValues/actionBtn": [
		4937,
		4937
	],
	"./pages/flashcards/listOfValues/actionBtn/": [
		4937,
		4937
	],
	"./pages/flashcards/listOfValues/actionBtn/index": [
		4937,
		4937
	],
	"./pages/flashcards/listOfValues/actionBtn/index.js": [
		4937,
		4937
	],
	"./pages/flashcards/listOfValues/index": [
		7748,
		2483,
		6807,
		1222,
		116,
		7748
	],
	"./pages/flashcards/listOfValues/index.js": [
		7748,
		2483,
		6807,
		1222,
		116,
		7748
	],
	"./pages/flashcards/listOfValues/list": [
		7821,
		2483,
		7821
	],
	"./pages/flashcards/listOfValues/list/": [
		7821,
		2483,
		7821
	],
	"./pages/flashcards/listOfValues/list/index": [
		7821,
		2483,
		7821
	],
	"./pages/flashcards/listOfValues/list/index.js": [
		7821,
		2483,
		7821
	],
	"./pages/learn/grammar/listOfPosts/Index": [
		9206,
		2483,
		6807,
		9206
	],
	"./pages/learn/grammar/listOfPosts/Index.js": [
		9206,
		2483,
		6807,
		9206
	],
	"./pages/learn/grammar/postData/Index": [
		2264,
		3469
	],
	"./pages/learn/grammar/postData/Index.js": [
		2264,
		3469
	],
	"./pages/learn/grammar/postData/a1/a-an-plurals": [
		1060,
		2483,
		6807,
		1060
	],
	"./pages/learn/grammar/postData/a1/a-an-plurals.js": [
		1060,
		2483,
		6807,
		1060
	],
	"./pages/learn/grammar/postData/a1/a-an-the-no-article": [
		4561,
		2483,
		6807,
		4561
	],
	"./pages/learn/grammar/postData/a1/a-an-the-no-article.js": [
		4561,
		2483,
		6807,
		4561
	],
	"./pages/learn/grammar/postData/a1/adjectives": [
		5247,
		2483,
		6807,
		5247
	],
	"./pages/learn/grammar/postData/a1/adjectives-and-subject-pronouns": [
		3591,
		2483,
		6807,
		3591
	],
	"./pages/learn/grammar/postData/a1/adjectives-and-subject-pronouns.js": [
		3591,
		2483,
		6807,
		3591
	],
	"./pages/learn/grammar/postData/a1/adjectives.js": [
		5247,
		2483,
		6807,
		5247
	],
	"./pages/learn/grammar/postData/a1/adverbs": [
		5746,
		2483,
		6807,
		5746
	],
	"./pages/learn/grammar/postData/a1/adverbs-of-frequency": [
		1897,
		2483,
		6807,
		1897
	],
	"./pages/learn/grammar/postData/a1/adverbs-of-frequency.js": [
		1897,
		2483,
		6807,
		1897
	],
	"./pages/learn/grammar/postData/a1/adverbs.js": [
		5746,
		2483,
		6807,
		5746
	],
	"./pages/learn/grammar/postData/a1/basic-word-order": [
		1907,
		2483,
		6807,
		1907
	],
	"./pages/learn/grammar/postData/a1/basic-word-order.js": [
		1907,
		2483,
		6807,
		1907
	],
	"./pages/learn/grammar/postData/a1/be-going-to-plans-predictions": [
		5937,
		2483,
		6807,
		5937
	],
	"./pages/learn/grammar/postData/a1/be-going-to-plans-predictions.js": [
		5937,
		2483,
		6807,
		5937
	],
	"./pages/learn/grammar/postData/a1/can-cant": [
		4704,
		2483,
		6807,
		4704
	],
	"./pages/learn/grammar/postData/a1/can-cant.js": [
		4704,
		2483,
		6807,
		4704
	],
	"./pages/learn/grammar/postData/a1/comparative-adjectives": [
		7947,
		2483,
		6807,
		7947
	],
	"./pages/learn/grammar/postData/a1/comparative-adjectives.js": [
		7947,
		2483,
		6807,
		7947
	],
	"./pages/learn/grammar/postData/a1/conjunctions": [
		5194,
		2483,
		6807,
		5194
	],
	"./pages/learn/grammar/postData/a1/conjunctions.js": [
		5194,
		2483,
		6807,
		5194
	],
	"./pages/learn/grammar/postData/a1/countable-uncountable": [
		9983,
		2483,
		6807,
		9983
	],
	"./pages/learn/grammar/postData/a1/countable-uncountable.js": [
		9983,
		2483,
		6807,
		9983
	],
	"./pages/learn/grammar/postData/a1/imperative": [
		5781,
		2483,
		6807,
		5781
	],
	"./pages/learn/grammar/postData/a1/imperative.js": [
		5781,
		2483,
		6807,
		5781
	],
	"./pages/learn/grammar/postData/a1/much-many-lot-little-few": [
		1088,
		2483,
		6807,
		1088
	],
	"./pages/learn/grammar/postData/a1/much-many-lot-little-few.js": [
		1088,
		2483,
		6807,
		1088
	],
	"./pages/learn/grammar/postData/a1/object-pronouns": [
		5017,
		2483,
		6807,
		5017
	],
	"./pages/learn/grammar/postData/a1/object-pronouns.js": [
		5017,
		2483,
		6807,
		5017
	],
	"./pages/learn/grammar/postData/a1/past-simple-negatives-questions": [
		7063,
		2483,
		6807,
		7063
	],
	"./pages/learn/grammar/postData/a1/past-simple-negatives-questions.js": [
		7063,
		2483,
		6807,
		7063
	],
	"./pages/learn/grammar/postData/a1/past-simple-regular-irregular": [
		1187,
		2483,
		6807,
		1187
	],
	"./pages/learn/grammar/postData/a1/past-simple-regular-irregular.js": [
		1187,
		2483,
		6807,
		1187
	],
	"./pages/learn/grammar/postData/a1/prepositions-of-place": [
		8626,
		2483,
		6807,
		8626
	],
	"./pages/learn/grammar/postData/a1/prepositions-of-place-next-to": [
		1634,
		2483,
		6807,
		1634
	],
	"./pages/learn/grammar/postData/a1/prepositions-of-place-next-to.js": [
		1634,
		2483,
		6807,
		1634
	],
	"./pages/learn/grammar/postData/a1/prepositions-of-place.js": [
		8626,
		2483,
		6807,
		8626
	],
	"./pages/learn/grammar/postData/a1/prepositions-of-time": [
		508,
		2483,
		6807,
		508
	],
	"./pages/learn/grammar/postData/a1/prepositions-of-time.js": [
		508,
		2483,
		6807,
		508
	],
	"./pages/learn/grammar/postData/a1/present-continuous": [
		6614,
		2483,
		6807,
		6614
	],
	"./pages/learn/grammar/postData/a1/present-continuous.js": [
		6614,
		2483,
		6807,
		6614
	],
	"./pages/learn/grammar/postData/a1/present-simple-form-of-to-do": [
		7562,
		2483,
		6807,
		7562
	],
	"./pages/learn/grammar/postData/a1/present-simple-form-of-to-do.js": [
		7562,
		2483,
		6807,
		7562
	],
	"./pages/learn/grammar/postData/a1/present-simple-forms-of-to-be": [
		8391,
		2483,
		6807,
		8391
	],
	"./pages/learn/grammar/postData/a1/present-simple-forms-of-to-be.js": [
		8391,
		2483,
		6807,
		8391
	],
	"./pages/learn/grammar/postData/a1/present-simple-present-continuous": [
		7577,
		2483,
		6807,
		7577
	],
	"./pages/learn/grammar/postData/a1/present-simple-present-continuous.js": [
		7577,
		2483,
		6807,
		7577
	],
	"./pages/learn/grammar/postData/a1/questions-word-order": [
		9290,
		2483,
		6807,
		9290
	],
	"./pages/learn/grammar/postData/a1/questions-word-order.js": [
		9290,
		2483,
		6807,
		9290
	],
	"./pages/learn/grammar/postData/a1/superlative-adjectives": [
		7386,
		2483,
		6807,
		7386
	],
	"./pages/learn/grammar/postData/a1/superlative-adjectives.js": [
		7386,
		2483,
		6807,
		7386
	],
	"./pages/learn/grammar/postData/a1/there-is-there-are": [
		4870,
		2483,
		6807,
		4870
	],
	"./pages/learn/grammar/postData/a1/there-is-there-are.js": [
		4870,
		2483,
		6807,
		4870
	],
	"./pages/learn/grammar/postData/a1/there-or-it": [
		7233,
		2483,
		6807,
		7233
	],
	"./pages/learn/grammar/postData/a1/there-or-it.js": [
		7233,
		2483,
		6807,
		7233
	],
	"./pages/learn/grammar/postData/a1/this-or-it": [
		8839,
		2483,
		6807,
		8839
	],
	"./pages/learn/grammar/postData/a1/this-or-it.js": [
		8839,
		2483,
		6807,
		8839
	],
	"./pages/learn/grammar/postData/a1/this-these-that-those": [
		415,
		2483,
		6807,
		415
	],
	"./pages/learn/grammar/postData/a1/this-these-that-those.js": [
		415,
		2483,
		6807,
		415
	],
	"./pages/learn/grammar/postData/a1/verbs-infinitive-verbs-ing": [
		7557,
		2483,
		6807,
		7557
	],
	"./pages/learn/grammar/postData/a1/verbs-infinitive-verbs-ing.js": [
		7557,
		2483,
		6807,
		7557
	],
	"./pages/learn/grammar/postData/a1/was-were": [
		122,
		2483,
		6807,
		122
	],
	"./pages/learn/grammar/postData/a1/was-were.js": [
		122,
		2483,
		6807,
		122
	],
	"./pages/learn/grammar/postData/a1/whose-possessive-s": [
		2182,
		2483,
		6807,
		2182
	],
	"./pages/learn/grammar/postData/a1/whose-possessive-s.js": [
		2182,
		2483,
		6807,
		2182
	],
	"./pages/learn/grammar/postData/a1/will-and-shall": [
		9600,
		2483,
		6807,
		9600
	],
	"./pages/learn/grammar/postData/a1/will-and-shall.js": [
		9600,
		2483,
		6807,
		9600
	],
	"./pages/learn/grammar/postData/a1/would-like": [
		6556,
		2483,
		6807,
		6556
	],
	"./pages/learn/grammar/postData/a1/would-like.js": [
		6556,
		2483,
		6807,
		6556
	],
	"./pages/learn/grammar/postData/a2/active-vs-passive-sentences": [
		6651,
		2483,
		6807,
		6651
	],
	"./pages/learn/grammar/postData/a2/active-vs-passive-sentences.js": [
		6651,
		2483,
		6807,
		6651
	],
	"./pages/learn/grammar/postData/a2/comparative-superlative-adjectives": [
		5237,
		2483,
		6807,
		5237
	],
	"./pages/learn/grammar/postData/a2/comparative-superlative-adjectives.js": [
		5237,
		2483,
		6807,
		5237
	],
	"./pages/learn/grammar/postData/a2/defining-relative-clauses": [
		4022,
		2483,
		6807,
		4022
	],
	"./pages/learn/grammar/postData/a2/defining-relative-clauses.js": [
		4022,
		2483,
		6807,
		4022
	],
	"./pages/learn/grammar/postData/a2/do-vs-make": [
		4648,
		2483,
		6807,
		4648
	],
	"./pages/learn/grammar/postData/a2/do-vs-make.js": [
		4648,
		2483,
		6807,
		4648
	],
	"./pages/learn/grammar/postData/a2/first-conditional": [
		6957,
		2483,
		6807,
		6957
	],
	"./pages/learn/grammar/postData/a2/first-conditional.js": [
		6957,
		2483,
		6807,
		6957
	],
	"./pages/learn/grammar/postData/a2/have-to-dont-have-to-must-mustnt": [
		6495,
		2483,
		6807,
		6495
	],
	"./pages/learn/grammar/postData/a2/have-to-dont-have-to-must-mustnt.js": [
		6495,
		2483,
		6807,
		6495
	],
	"./pages/learn/grammar/postData/a2/however-although-time-connectors": [
		3626,
		2483,
		6807,
		3626
	],
	"./pages/learn/grammar/postData/a2/however-although-time-connectors.js": [
		3626,
		2483,
		6807,
		3626
	],
	"./pages/learn/grammar/postData/a2/might-might-not": [
		4239,
		2483,
		6807,
		4239
	],
	"./pages/learn/grammar/postData/a2/might-might-not.js": [
		4239,
		2483,
		6807,
		4239
	],
	"./pages/learn/grammar/postData/a2/most-most-of-the-most": [
		7343,
		2483,
		6807,
		7343
	],
	"./pages/learn/grammar/postData/a2/most-most-of-the-most.js": [
		7343,
		2483,
		6807,
		7343
	],
	"./pages/learn/grammar/postData/a2/no-longer-any-longer-anymore": [
		2872,
		2483,
		6807,
		2872
	],
	"./pages/learn/grammar/postData/a2/no-longer-any-longer-anymore.js": [
		2872,
		2483,
		6807,
		2872
	],
	"./pages/learn/grammar/postData/a2/on-time-vs-in-time-at-the-end-vs-in-the-end": [
		9515,
		2483,
		6807,
		9515
	],
	"./pages/learn/grammar/postData/a2/on-time-vs-in-time-at-the-end-vs-in-the-end.js": [
		9515,
		2483,
		6807,
		9515
	],
	"./pages/learn/grammar/postData/a2/past-continuous-form-use": [
		2783,
		2483,
		6807,
		2783
	],
	"./pages/learn/grammar/postData/a2/past-continuous-form-use.js": [
		2783,
		2483,
		6807,
		2783
	],
	"./pages/learn/grammar/postData/a2/past-continuous-past-simple": [
		2530,
		2483,
		6807,
		2530
	],
	"./pages/learn/grammar/postData/a2/past-continuous-past-simple.js": [
		2530,
		2483,
		6807,
		2530
	],
	"./pages/learn/grammar/postData/a2/past-perfect": [
		9668,
		2483,
		6807,
		9668
	],
	"./pages/learn/grammar/postData/a2/past-perfect.js": [
		9668,
		2483,
		6807,
		9668
	],
	"./pages/learn/grammar/postData/a2/phrasal-verbs-transitive-and-intransitive-separable-and-inseparable": [
		3756,
		2483,
		6807,
		3756
	],
	"./pages/learn/grammar/postData/a2/phrasal-verbs-transitive-and-intransitive-separable-and-inseparable.js": [
		3756,
		2483,
		6807,
		3756
	],
	"./pages/learn/grammar/postData/a2/prepositions-of-movement": [
		3375,
		2483,
		6807,
		3375
	],
	"./pages/learn/grammar/postData/a2/prepositions-of-movement.js": [
		3375,
		2483,
		6807,
		3375
	],
	"./pages/learn/grammar/postData/a2/present-continuous-future-arrangements": [
		1359,
		2483,
		6807,
		1359
	],
	"./pages/learn/grammar/postData/a2/present-continuous-future-arrangements.js": [
		1359,
		2483,
		6807,
		1359
	],
	"./pages/learn/grammar/postData/a2/present-past-simple-passive": [
		6045,
		2483,
		6807,
		6045
	],
	"./pages/learn/grammar/postData/a2/present-past-simple-passive.js": [
		6045,
		2483,
		6807,
		6045
	],
	"./pages/learn/grammar/postData/a2/present-perfect": [
		8029,
		2483,
		6807,
		8029
	],
	"./pages/learn/grammar/postData/a2/present-perfect-or-past-simple": [
		6803,
		2483,
		6807,
		6803
	],
	"./pages/learn/grammar/postData/a2/present-perfect-or-past-simple.js": [
		6803,
		2483,
		6807,
		6803
	],
	"./pages/learn/grammar/postData/a2/present-perfect.js": [
		8029,
		2483,
		6807,
		8029
	],
	"./pages/learn/grammar/postData/a2/purpose-to-for": [
		6814,
		2483,
		6807,
		6814
	],
	"./pages/learn/grammar/postData/a2/purpose-to-for.js": [
		6814,
		2483,
		6807,
		6814
	],
	"./pages/learn/grammar/postData/a2/reported-speech": [
		7746,
		2483,
		6807,
		7746
	],
	"./pages/learn/grammar/postData/a2/reported-speech.js": [
		7746,
		2483,
		6807,
		7746
	],
	"./pages/learn/grammar/postData/a2/second-conditional": [
		9385,
		2483,
		6807,
		9385
	],
	"./pages/learn/grammar/postData/a2/second-conditional.js": [
		9385,
		2483,
		6807,
		9385
	],
	"./pages/learn/grammar/postData/a2/should-shouldnt": [
		3013,
		2483,
		6807,
		3013
	],
	"./pages/learn/grammar/postData/a2/should-shouldnt.js": [
		3013,
		2483,
		6807,
		3013
	],
	"./pages/learn/grammar/postData/a2/so-neither": [
		688,
		2483,
		6807,
		688
	],
	"./pages/learn/grammar/postData/a2/so-neither.js": [
		688,
		2483,
		6807,
		688
	],
	"./pages/learn/grammar/postData/a2/something-anything-nothing-etc": [
		6298,
		2483,
		6807,
		6298
	],
	"./pages/learn/grammar/postData/a2/something-anything-nothing-etc.js": [
		6298,
		2483,
		6807,
		6298
	],
	"./pages/learn/grammar/postData/a2/stative-vs-dynamic-verbs": [
		1079,
		2483,
		6807,
		1079
	],
	"./pages/learn/grammar/postData/a2/stative-vs-dynamic-verbs.js": [
		1079,
		2483,
		6807,
		1079
	],
	"./pages/learn/grammar/postData/a2/subject-questions-questions-preposition": [
		1105,
		2483,
		6807,
		1105
	],
	"./pages/learn/grammar/postData/a2/subject-questions-questions-preposition.js": [
		1105,
		2483,
		6807,
		1105
	],
	"./pages/learn/grammar/postData/a2/the-different-uses-of-the-verb-get": [
		4485,
		2483,
		6807,
		4485
	],
	"./pages/learn/grammar/postData/a2/the-different-uses-of-the-verb-get.js": [
		4485,
		2483,
		6807,
		4485
	],
	"./pages/learn/grammar/postData/a2/too-too-much-too-many-enough": [
		449,
		2483,
		6807,
		449
	],
	"./pages/learn/grammar/postData/a2/too-too-much-too-many-enough.js": [
		449,
		2483,
		6807,
		449
	],
	"./pages/learn/grammar/postData/a2/used-to-past-habits-and-states": [
		2301,
		2483,
		6807,
		2301
	],
	"./pages/learn/grammar/postData/a2/used-to-past-habits-and-states.js": [
		2301,
		2483,
		6807,
		2301
	],
	"./pages/learn/grammar/postData/a2/uses-of-the-verb-go": [
		4137,
		2483,
		6807,
		4137
	],
	"./pages/learn/grammar/postData/a2/uses-of-the-verb-go.js": [
		4137,
		2483,
		6807,
		4137
	],
	"./pages/learn/grammar/postData/a2/verbs-with-two-objects": [
		9591,
		2483,
		6807,
		9591
	],
	"./pages/learn/grammar/postData/a2/verbs-with-two-objects.js": [
		9591,
		2483,
		6807,
		9591
	],
	"./pages/learn/grammar/postData/a2/will-vs-be-going-to": [
		4927,
		2483,
		6807,
		4927
	],
	"./pages/learn/grammar/postData/a2/will-vs-be-going-to.js": [
		4927,
		2483,
		6807,
		4927
	],
	"./pages/learn/grammar/postData/b1/adjective-preposition": [
		2904,
		2483,
		6807,
		2904
	],
	"./pages/learn/grammar/postData/b1/adjective-preposition.js": [
		2904,
		2483,
		6807,
		2904
	],
	"./pages/learn/grammar/postData/b1/all-both": [
		1843,
		2483,
		6807,
		1843
	],
	"./pages/learn/grammar/postData/b1/all-both.js": [
		1843,
		2483,
		6807,
		1843
	],
	"./pages/learn/grammar/postData/b1/an-the-no-article": [
		6140,
		2483,
		6807,
		6140
	],
	"./pages/learn/grammar/postData/b1/an-the-no-article.js": [
		6140,
		2483,
		6807,
		6140
	],
	"./pages/learn/grammar/postData/b1/another-other-others-the-other-the-others": [
		4401,
		2483,
		6807,
		4401
	],
	"./pages/learn/grammar/postData/b1/another-other-others-the-other-the-others.js": [
		4401,
		2483,
		6807,
		4401
	],
	"./pages/learn/grammar/postData/b1/any-no-none": [
		7559,
		2483,
		6807,
		7559
	],
	"./pages/learn/grammar/postData/b1/any-no-none.js": [
		7559,
		2483,
		6807,
		7559
	],
	"./pages/learn/grammar/postData/b1/both-either-neither": [
		5961,
		2483,
		6807,
		5961
	],
	"./pages/learn/grammar/postData/b1/both-either-neither.js": [
		5961,
		2483,
		6807,
		5961
	],
	"./pages/learn/grammar/postData/b1/can-could-be-able-to": [
		8557,
		2483,
		6807,
		8557
	],
	"./pages/learn/grammar/postData/b1/can-could-be-able-to.js": [
		8557,
		2483,
		6807,
		8557
	],
	"./pages/learn/grammar/postData/b1/clauses-contrast-purpose-reason": [
		87,
		2483,
		6807,
		87
	],
	"./pages/learn/grammar/postData/b1/clauses-contrast-purpose-reason.js": [
		87,
		2483,
		6807,
		87
	],
	"./pages/learn/grammar/postData/b1/compound-adjectives-with-numbers": [
		586,
		2483,
		6807,
		586
	],
	"./pages/learn/grammar/postData/b1/compound-adjectives-with-numbers.js": [
		586,
		2483,
		6807,
		586
	],
	"./pages/learn/grammar/postData/b1/defining-and-non-defining-relative-clauses": [
		8313,
		2483,
		6807,
		8313
	],
	"./pages/learn/grammar/postData/b1/defining-and-non-defining-relative-clauses.js": [
		8313,
		2483,
		6807,
		8313
	],
	"./pages/learn/grammar/postData/b1/during-for-while": [
		1213,
		2483,
		6807,
		1213
	],
	"./pages/learn/grammar/postData/b1/during-for-while.js": [
		1213,
		2483,
		6807,
		1213
	],
	"./pages/learn/grammar/postData/b1/ed-ing-adjectives": [
		4979,
		2483,
		6807,
		4979
	],
	"./pages/learn/grammar/postData/b1/ed-ing-adjectives.js": [
		4979,
		2483,
		6807,
		4979
	],
	"./pages/learn/grammar/postData/b1/first-and-second-conditionals": [
		789,
		2483,
		6807,
		789
	],
	"./pages/learn/grammar/postData/b1/first-and-second-conditionals.js": [
		789,
		2483,
		6807,
		789
	],
	"./pages/learn/grammar/postData/b1/for-since-from": [
		9497,
		2483,
		6807,
		9497
	],
	"./pages/learn/grammar/postData/b1/for-since-from.js": [
		9497,
		2483,
		6807,
		9497
	],
	"./pages/learn/grammar/postData/b1/future-forms": [
		5419,
		2483,
		6807,
		5419
	],
	"./pages/learn/grammar/postData/b1/future-forms.js": [
		5419,
		2483,
		6807,
		5419
	],
	"./pages/learn/grammar/postData/b1/had-better-its-time": [
		2245,
		2483,
		6807,
		2245
	],
	"./pages/learn/grammar/postData/b1/had-better-its-time.js": [
		2245,
		2483,
		6807,
		2245
	],
	"./pages/learn/grammar/postData/b1/have-to-must-should": [
		8210,
		2483,
		6807,
		8210
	],
	"./pages/learn/grammar/postData/b1/have-to-must-should.js": [
		8210,
		2483,
		6807,
		8210
	],
	"./pages/learn/grammar/postData/b1/have-to-or-must": [
		9672,
		2483,
		6807,
		9672
	],
	"./pages/learn/grammar/postData/b1/have-to-or-must.js": [
		9672,
		2483,
		6807,
		9672
	],
	"./pages/learn/grammar/postData/b1/modal-verbs-of-deduction": [
		3640,
		2483,
		6807,
		3640
	],
	"./pages/learn/grammar/postData/b1/modal-verbs-of-deduction.js": [
		3640,
		2483,
		6807,
		3640
	],
	"./pages/learn/grammar/postData/b1/nothing-anything": [
		6248,
		2483,
		6807,
		6248
	],
	"./pages/learn/grammar/postData/b1/nothing-anything.js": [
		6248,
		2483,
		6807,
		6248
	],
	"./pages/learn/grammar/postData/b1/passive-verb-forms": [
		8125,
		2483,
		6807,
		8125
	],
	"./pages/learn/grammar/postData/b1/passive-verb-forms.js": [
		8125,
		2483,
		6807,
		8125
	],
	"./pages/learn/grammar/postData/b1/past-simple-past-continuous-past-perfect": [
		3853,
		2483,
		6807,
		3853
	],
	"./pages/learn/grammar/postData/b1/past-simple-past-continuous-past-perfect.js": [
		3853,
		2483,
		6807,
		3853
	],
	"./pages/learn/grammar/postData/b1/past-simple-present-perfect": [
		5775,
		2483,
		6807,
		5775
	],
	"./pages/learn/grammar/postData/b1/past-simple-present-perfect.js": [
		5775,
		2483,
		6807,
		5775
	],
	"./pages/learn/grammar/postData/b1/present-perfect-simple-present-perfect-continuous": [
		2130,
		2483,
		6807,
		2130
	],
	"./pages/learn/grammar/postData/b1/present-perfect-simple-present-perfect-continuous.js": [
		2130,
		2483,
		6807,
		2130
	],
	"./pages/learn/grammar/postData/b1/present-simple-present-continuous": [
		3926,
		2483,
		6807,
		3926
	],
	"./pages/learn/grammar/postData/b1/present-simple-present-continuous.js": [
		3926,
		2483,
		6807,
		3926
	],
	"./pages/learn/grammar/postData/b1/question-tags": [
		1918,
		2483,
		6807,
		1918
	],
	"./pages/learn/grammar/postData/b1/question-tags.js": [
		1918,
		2483,
		6807,
		1918
	],
	"./pages/learn/grammar/postData/b1/reflexive-pronouns": [
		9569,
		2483,
		6807,
		9569
	],
	"./pages/learn/grammar/postData/b1/reflexive-pronouns.js": [
		9569,
		2483,
		6807,
		9569
	],
	"./pages/learn/grammar/postData/b1/reported-speech-indirect-speech": [
		2206,
		2483,
		6807,
		2206
	],
	"./pages/learn/grammar/postData/b1/reported-speech-indirect-speech.js": [
		2206,
		2483,
		6807,
		2206
	],
	"./pages/learn/grammar/postData/b1/so-such-such-a-so-much-so-many": [
		1064,
		2483,
		6807,
		1064
	],
	"./pages/learn/grammar/postData/b1/so-such-such-a-so-much-so-many.js": [
		1064,
		2483,
		6807,
		1064
	],
	"./pages/learn/grammar/postData/b1/third-conditional-past-unreal-situations": [
		2907,
		2483,
		6807,
		2907
	],
	"./pages/learn/grammar/postData/b1/third-conditional-past-unreal-situations.js": [
		2907,
		2483,
		6807,
		2907
	],
	"./pages/learn/grammar/postData/b1/used-to-be-used-to-get-used-to": [
		9218,
		2483,
		6807,
		9218
	],
	"./pages/learn/grammar/postData/b1/used-to-be-used-to-get-used-to.js": [
		9218,
		2483,
		6807,
		9218
	],
	"./pages/learn/grammar/postData/b1/verb-preposition": [
		9116,
		2483,
		6807,
		9116
	],
	"./pages/learn/grammar/postData/b1/verb-preposition.js": [
		9116,
		2483,
		6807,
		9116
	],
	"./pages/learn/grammar/postData/b1/would-rather-would-sooner": [
		6909,
		2483,
		6807,
		6909
	],
	"./pages/learn/grammar/postData/b1/would-rather-would-sooner.js": [
		6909,
		2483,
		6807,
		6909
	],
	"./pages/learn/grammar/postData/b2/adjectives-without-noun": [
		9605,
		2483,
		6807,
		9605
	],
	"./pages/learn/grammar/postData/b2/adjectives-without-noun.js": [
		9605,
		2483,
		6807,
		9605
	],
	"./pages/learn/grammar/postData/b2/already-still-yet-whats-the-difference": [
		2093,
		2483,
		6807,
		2093
	],
	"./pages/learn/grammar/postData/b2/already-still-yet-whats-the-difference.js": [
		2093,
		2483,
		6807,
		2093
	],
	"./pages/learn/grammar/postData/b2/auxiliary-verbs-different-uses": [
		535,
		2483,
		6807,
		535
	],
	"./pages/learn/grammar/postData/b2/auxiliary-verbs-different-uses.js": [
		535,
		2483,
		6807,
		535
	],
	"./pages/learn/grammar/postData/b2/clauses-contrast-purpose": [
		8613,
		2483,
		6807,
		8613
	],
	"./pages/learn/grammar/postData/b2/clauses-contrast-purpose.js": [
		8613,
		2483,
		6807,
		8613
	],
	"./pages/learn/grammar/postData/b2/do-or-make": [
		5563,
		2483,
		6807,
		5563
	],
	"./pages/learn/grammar/postData/b2/do-or-make.js": [
		5563,
		2483,
		6807,
		5563
	],
	"./pages/learn/grammar/postData/b2/future-continuous": [
		2488,
		2483,
		6807,
		2488
	],
	"./pages/learn/grammar/postData/b2/future-continuous.js": [
		2488,
		2483,
		6807,
		2488
	],
	"./pages/learn/grammar/postData/b2/future-perfect": [
		7398,
		2483,
		6807,
		7398
	],
	"./pages/learn/grammar/postData/b2/future-perfect.js": [
		7398,
		2483,
		6807,
		7398
	],
	"./pages/learn/grammar/postData/b2/have-something-done": [
		8507,
		2483,
		6807,
		8507
	],
	"./pages/learn/grammar/postData/b2/have-something-done.js": [
		8507,
		2483,
		6807,
		8507
	],
	"./pages/learn/grammar/postData/b2/indirect-questions": [
		3156,
		2483,
		6807,
		775
	],
	"./pages/learn/grammar/postData/b2/indirect-questions.js": [
		3156,
		2483,
		6807,
		775
	],
	"./pages/learn/grammar/postData/b2/likely-unlikely-bound-definitely-probably": [
		3460,
		2483,
		6807,
		3460
	],
	"./pages/learn/grammar/postData/b2/likely-unlikely-bound-definitely-probably.js": [
		3460,
		2483,
		6807,
		3460
	],
	"./pages/learn/grammar/postData/b2/neednt-dont-need-to-didnt-need-to-neednt-have": [
		8091,
		2483,
		6807,
		8091
	],
	"./pages/learn/grammar/postData/b2/neednt-dont-need-to-didnt-need-to-neednt-have.js": [
		8091,
		2483,
		6807,
		8091
	],
	"./pages/learn/grammar/postData/b2/participle-adjectives": [
		8991,
		2483,
		6807,
		8991
	],
	"./pages/learn/grammar/postData/b2/participle-adjectives.js": [
		8991,
		2483,
		6807,
		8991
	],
	"./pages/learn/grammar/postData/b2/passive-reporting-verbs": [
		5860,
		2483,
		6807,
		5860
	],
	"./pages/learn/grammar/postData/b2/passive-reporting-verbs.js": [
		5860,
		2483,
		6807,
		5860
	],
	"./pages/learn/grammar/postData/b2/past-modal-verbs": [
		5898,
		2483,
		6807,
		5898
	],
	"./pages/learn/grammar/postData/b2/past-modal-verbs.js": [
		5898,
		2483,
		6807,
		5898
	],
	"./pages/learn/grammar/postData/b2/position-of-adverbs": [
		2602,
		2483,
		6807,
		2602
	],
	"./pages/learn/grammar/postData/b2/position-of-adverbs.js": [
		2602,
		2483,
		6807,
		2602
	],
	"./pages/learn/grammar/postData/b2/present-perfect-simple-continuous": [
		4041,
		2483,
		6807,
		4041
	],
	"./pages/learn/grammar/postData/b2/present-perfect-simple-continuous.js": [
		4041,
		2483,
		6807,
		4041
	],
	"./pages/learn/grammar/postData/b2/pretty-rather-quite-fairly-intensifiers": [
		3523,
		2483,
		6807,
		3523
	],
	"./pages/learn/grammar/postData/b2/pretty-rather-quite-fairly-intensifiers.js": [
		3523,
		2483,
		6807,
		3523
	],
	"./pages/learn/grammar/postData/b2/quantifiers": [
		9936,
		2483,
		6807,
		9936
	],
	"./pages/learn/grammar/postData/b2/quantifiers.js": [
		9936,
		2483,
		6807,
		9936
	],
	"./pages/learn/grammar/postData/b2/reporting-verbs": [
		2040,
		2483,
		6807,
		2040
	],
	"./pages/learn/grammar/postData/b2/reporting-verbs.js": [
		2040,
		2483,
		6807,
		2040
	],
	"./pages/learn/grammar/postData/b2/second-third-conditionals": [
		9899,
		2483,
		6807,
		9899
	],
	"./pages/learn/grammar/postData/b2/second-third-conditionals.js": [
		9899,
		2483,
		6807,
		9899
	],
	"./pages/learn/grammar/postData/b2/so-such-a-so-much-so-many": [
		9303,
		2483,
		6807,
		9303
	],
	"./pages/learn/grammar/postData/b2/so-such-a-so-much-so-many.js": [
		9303,
		2483,
		6807,
		9303
	],
	"./pages/learn/grammar/postData/b2/the-the-comparatives": [
		7371,
		2483,
		6807,
		7371
	],
	"./pages/learn/grammar/postData/b2/the-the-comparatives.js": [
		7371,
		2483,
		6807,
		7371
	],
	"./pages/learn/grammar/postData/b2/whatever-whenever-wherever-whoever-however": [
		5724,
		2483,
		6807,
		3343
	],
	"./pages/learn/grammar/postData/b2/whatever-whenever-wherever-whoever-however.js": [
		5724,
		2483,
		6807,
		3343
	],
	"./pages/learn/grammar/postData/b2/when-i-do-vs-when-i-have-done": [
		7916,
		2483,
		6807,
		7916
	],
	"./pages/learn/grammar/postData/b2/when-i-do-vs-when-i-have-done.js": [
		7916,
		2483,
		6807,
		7916
	],
	"./pages/learn/grammar/postData/b2/wishes-regrets": [
		1461,
		2483,
		6807,
		1461
	],
	"./pages/learn/grammar/postData/b2/wishes-regrets.js": [
		1461,
		2483,
		6807,
		1461
	],
	"./pages/learn/grammar/postData/b2/would-and-used-to": [
		452,
		2483,
		6807,
		452
	],
	"./pages/learn/grammar/postData/b2/would-and-used-to.js": [
		452,
		2483,
		6807,
		452
	],
	"./pages/learn/grammar/postData/b2/would-rather-would-prefer": [
		8802,
		2483,
		6807,
		8802
	],
	"./pages/learn/grammar/postData/b2/would-rather-would-prefer.js": [
		8802,
		2483,
		6807,
		8802
	],
	"./pages/learn/grammar/postData/b2/zero-first-conditional": [
		3486,
		2483,
		6807,
		3486
	],
	"./pages/learn/grammar/postData/b2/zero-first-conditional.js": [
		3486,
		2483,
		6807,
		3486
	],
	"./pages/learn/grammar/postData/b2a/all-conditionals": [
		4909,
		2483,
		6807,
		4909
	],
	"./pages/learn/grammar/postData/b2a/all-conditionals.js": [
		4909,
		2483,
		6807,
		4909
	],
	"./pages/learn/grammar/postData/b2a/clauses-contrast-purpose-reason-result": [
		7417,
		2483,
		6807,
		7417
	],
	"./pages/learn/grammar/postData/b2a/clauses-contrast-purpose-reason-result.js": [
		7417,
		2483,
		6807,
		7417
	],
	"./pages/learn/grammar/postData/b2a/discourse-markers": [
		1543,
		2483,
		6807,
		1543
	],
	"./pages/learn/grammar/postData/b2a/discourse-markers.js": [
		1543,
		2483,
		6807,
		1543
	],
	"./pages/learn/grammar/postData/b2a/distancing": [
		3554,
		2483,
		6807,
		3554
	],
	"./pages/learn/grammar/postData/b2a/distancing.js": [
		3554,
		2483,
		6807,
		3554
	],
	"./pages/learn/grammar/postData/b2a/future-forms-expressing-future-time": [
		9630,
		2483,
		6807,
		9630
	],
	"./pages/learn/grammar/postData/b2a/future-forms-expressing-future-time.js": [
		9630,
		2483,
		6807,
		9630
	],
	"./pages/learn/grammar/postData/b2a/future-in-the-past": [
		3680,
		2483,
		6807,
		3680
	],
	"./pages/learn/grammar/postData/b2a/future-in-the-past.js": [
		3680,
		2483,
		6807,
		3680
	],
	"./pages/learn/grammar/postData/b2a/future-other-ways-express": [
		6222,
		2483,
		6807,
		6222
	],
	"./pages/learn/grammar/postData/b2a/future-other-ways-express.js": [
		6222,
		2483,
		6807,
		6222
	],
	"./pages/learn/grammar/postData/b2a/gerunds-infinitives-complex-forms": [
		4284,
		2483,
		6807,
		4284
	],
	"./pages/learn/grammar/postData/b2a/gerunds-infinitives-complex-forms.js": [
		4284,
		2483,
		6807,
		4284
	],
	"./pages/learn/grammar/postData/b2a/get": [
		224,
		2483,
		6807,
		224
	],
	"./pages/learn/grammar/postData/b2a/get.js": [
		224,
		2483,
		6807,
		224
	],
	"./pages/learn/grammar/postData/b2a/have": [
		3532,
		2483,
		6807,
		3532
	],
	"./pages/learn/grammar/postData/b2a/have.js": [
		3532,
		2483,
		6807,
		3532
	],
	"./pages/learn/grammar/postData/b2a/inversion-with-negative-adverbials": [
		814,
		2483,
		6807,
		814
	],
	"./pages/learn/grammar/postData/b2a/inversion-with-negative-adverbials.js": [
		814,
		2483,
		6807,
		814
	],
	"./pages/learn/grammar/postData/b2a/mixed-conditionals": [
		3537,
		2483,
		6807,
		3537
	],
	"./pages/learn/grammar/postData/b2a/mixed-conditionals.js": [
		3537,
		2483,
		6807,
		3537
	],
	"./pages/learn/grammar/postData/b2a/narrative-tenses-used-to-would": [
		1859,
		2483,
		6807,
		1859
	],
	"./pages/learn/grammar/postData/b2a/narrative-tenses-used-to-would.js": [
		1859,
		2483,
		6807,
		1859
	],
	"./pages/learn/grammar/postData/b2a/participle-clauses": [
		9230,
		2483,
		6807,
		9230
	],
	"./pages/learn/grammar/postData/b2a/participle-clauses.js": [
		9230,
		2483,
		6807,
		9230
	],
	"./pages/learn/grammar/postData/b2a/passive-verbs-with-two-objects": [
		609,
		2483,
		6807,
		609
	],
	"./pages/learn/grammar/postData/b2a/passive-verbs-with-two-objects.js": [
		609,
		2483,
		6807,
		609
	],
	"./pages/learn/grammar/postData/b2a/permission-obligation-prohibition-necessity": [
		5788,
		2483,
		6807,
		5788
	],
	"./pages/learn/grammar/postData/b2a/permission-obligation-prohibition-necessity.js": [
		5788,
		2483,
		6807,
		5788
	],
	"./pages/learn/grammar/postData/b2a/reflexive-reciprocal-pronouns": [
		6934,
		2483,
		6807,
		6934
	],
	"./pages/learn/grammar/postData/b2a/reflexive-reciprocal-pronouns.js": [
		6934,
		2483,
		6807,
		6934
	],
	"./pages/learn/grammar/postData/b2a/speculation-deduction": [
		3681,
		2483,
		6807,
		3681
	],
	"./pages/learn/grammar/postData/b2a/speculation-deduction.js": [
		3681,
		2483,
		6807,
		3681
	],
	"./pages/learn/grammar/postData/b2a/unless-even-if-provided-as-long-conditionals": [
		5947,
		2483,
		6807,
		5947
	],
	"./pages/learn/grammar/postData/b2a/unless-even-if-provided-as-long-conditionals.js": [
		5947,
		2483,
		6807,
		5947
	],
	"./pages/learn/grammar/postData/b2a/unreal-uses-past-tenses": [
		2068,
		2483,
		6807,
		2068
	],
	"./pages/learn/grammar/postData/b2a/unreal-uses-past-tenses.js": [
		2068,
		2483,
		6807,
		2068
	],
	"./pages/learn/grammar/postData/b2a/verb-object-infinitive-gerund": [
		6585,
		2483,
		6807,
		6585
	],
	"./pages/learn/grammar/postData/b2a/verb-object-infinitive-gerund.js": [
		6585,
		2483,
		6807,
		6585
	],
	"./pages/learn/grammar/postData/b2a/verbs-of-the-senses": [
		1006,
		2483,
		6807,
		1006
	],
	"./pages/learn/grammar/postData/b2a/verbs-of-the-senses.js": [
		1006,
		2483,
		6807,
		1006
	],
	"./pages/learn/grammar/postData/more-grammar/can-be-able-to": [
		4529,
		2483,
		6807,
		4529
	],
	"./pages/learn/grammar/postData/more-grammar/can-be-able-to.js": [
		4529,
		2483,
		6807,
		4529
	],
	"./pages/learn/grammar/postData/more-grammar/dealwith-handle-cope-manage": [
		6142,
		2483,
		6807,
		3761
	],
	"./pages/learn/grammar/postData/more-grammar/dealwith-handle-cope-manage.js": [
		6142,
		2483,
		6807,
		3761
	],
	"./pages/learn/grammar/postData/more-grammar/for-vs-to": [
		549,
		2483,
		6807,
		549
	],
	"./pages/learn/grammar/postData/more-grammar/for-vs-to.js": [
		549,
		2483,
		6807,
		549
	],
	"./pages/learn/grammar/postData/more-grammar/get-go-come-walk": [
		9860,
		2483,
		6807,
		9860
	],
	"./pages/learn/grammar/postData/more-grammar/get-go-come-walk.js": [
		9860,
		2483,
		6807,
		9860
	],
	"./pages/learn/grammar/postData/more-grammar/get-obtain-receive": [
		3116,
		2483,
		6807,
		3116
	],
	"./pages/learn/grammar/postData/more-grammar/get-obtain-receive.js": [
		3116,
		2483,
		6807,
		3116
	],
	"./pages/learn/grammar/postData/more-grammar/happens": [
		313,
		2483,
		6807,
		313
	],
	"./pages/learn/grammar/postData/more-grammar/happens.js": [
		313,
		2483,
		6807,
		313
	],
	"./pages/learn/grammar/postData/more-grammar/particular-specific-certain": [
		8601,
		2483,
		6807,
		8601
	],
	"./pages/learn/grammar/postData/more-grammar/particular-specific-certain.js": [
		8601,
		2483,
		6807,
		8601
	],
	"./pages/learn/grammar/postData/more-grammar/take-me-pick-up-to-get-to": [
		2415,
		2483,
		6807,
		2415
	],
	"./pages/learn/grammar/postData/more-grammar/take-me-pick-up-to-get-to.js": [
		2415,
		2483,
		6807,
		2415
	],
	"./pages/learn/listOfLevels/Index": [
		8694,
		2483,
		6807,
		8694
	],
	"./pages/learn/listOfLevels/Index.js": [
		8694,
		2483,
		6807,
		8694
	],
	"./pages/learn/postCreate/index/Index": [
		5373,
		2483,
		5373
	],
	"./pages/learn/postCreate/index/Index.js": [
		5373,
		2483,
		5373
	],
	"./pages/learn/vocabulary/listOfPosts/Index": [
		8979,
		2483,
		8979
	],
	"./pages/learn/vocabulary/listOfPosts/Index.js": [
		8979,
		2483,
		8979
	],
	"./pages/learn/vocabulary/postData/Index": [
		6771,
		9307
	],
	"./pages/learn/vocabulary/postData/Index.js": [
		6771,
		9307
	],
	"./pages/learn/vocabulary/postData/a1/clothes": [
		6914,
		2483,
		6807,
		6914
	],
	"./pages/learn/vocabulary/postData/a1/clothes.js": [
		6914,
		2483,
		6807,
		6914
	],
	"./pages/learn/vocabulary/postData/a1/daily-routines": [
		6333,
		2483,
		6807,
		6333
	],
	"./pages/learn/vocabulary/postData/a1/daily-routines.js": [
		6333,
		2483,
		6807,
		6333
	],
	"./pages/learn/vocabulary/postData/a1/days-months-seasons": [
		7716,
		2483,
		6807,
		7716
	],
	"./pages/learn/vocabulary/postData/a1/days-months-seasons.js": [
		7716,
		2483,
		6807,
		7716
	],
	"./pages/learn/vocabulary/postData/a1/family-and-relatives": [
		2720,
		2483,
		6807,
		2720
	],
	"./pages/learn/vocabulary/postData/a1/family-and-relatives.js": [
		2720,
		2483,
		6807,
		2720
	],
	"./pages/learn/vocabulary/postData/a1/food-and-meals": [
		1117,
		2483,
		6807,
		1117
	],
	"./pages/learn/vocabulary/postData/a1/food-and-meals.js": [
		1117,
		2483,
		6807,
		1117
	],
	"./pages/learn/vocabulary/postData/a1/housework": [
		8255,
		2483,
		6807,
		8255
	],
	"./pages/learn/vocabulary/postData/a1/housework.js": [
		8255,
		2483,
		6807,
		8255
	],
	"./pages/learn/vocabulary/postData/a1/opposite-adjectives": [
		2950,
		2483,
		6807,
		2950
	],
	"./pages/learn/vocabulary/postData/a1/opposite-adjectives.js": [
		2950,
		2483,
		6807,
		2950
	],
	"./pages/learn/vocabulary/postData/a1/parts-in-a-houses": [
		9532,
		2483,
		6807,
		9532
	],
	"./pages/learn/vocabulary/postData/a1/parts-in-a-houses.js": [
		9532,
		2483,
		6807,
		9532
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-a-bathroom": [
		6062,
		2483,
		6807,
		6062
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-a-bathroom.js": [
		6062,
		2483,
		6807,
		6062
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-a-bedroom": [
		9975,
		2483,
		6807,
		9975
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-a-bedroom.js": [
		9975,
		2483,
		6807,
		9975
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-a-kitchen": [
		8351,
		2483,
		6807,
		8351
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-a-kitchen.js": [
		8351,
		2483,
		6807,
		8351
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-rooms": [
		2693,
		2483,
		6807,
		2693
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-rooms.js": [
		2693,
		2483,
		6807,
		2693
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-the-body": [
		7139,
		2483,
		6807,
		7139
	],
	"./pages/learn/vocabulary/postData/a1/parts-of-the-body.js": [
		7139,
		2483,
		6807,
		7139
	],
	"./pages/learn/vocabulary/postData/a1/places-in-a-town": [
		4381,
		2483,
		6807,
		4381
	],
	"./pages/learn/vocabulary/postData/a1/places-in-a-town.js": [
		4381,
		2483,
		6807,
		4381
	],
	"./pages/learn/vocabulary/postData/a1/types-of-stores": [
		7732,
		2483,
		6807,
		7732
	],
	"./pages/learn/vocabulary/postData/a1/types-of-stores.js": [
		7732,
		2483,
		6807,
		7732
	],
	"./pages/learn/vocabulary/postData/a2/at-the-restaurant": [
		3862,
		2483,
		6807,
		3862
	],
	"./pages/learn/vocabulary/postData/a2/at-the-restaurant.js": [
		3862,
		2483,
		6807,
		3862
	],
	"./pages/learn/vocabulary/postData/a2/clothes-accessories": [
		8288,
		2483,
		6807,
		8288
	],
	"./pages/learn/vocabulary/postData/a2/clothes-accessories.js": [
		8288,
		2483,
		6807,
		8288
	],
	"./pages/learn/vocabulary/postData/a2/clothes-footwear": [
		8131,
		2483,
		6807,
		8131
	],
	"./pages/learn/vocabulary/postData/a2/clothes-footwear.js": [
		8131,
		2483,
		6807,
		8131
	],
	"./pages/learn/vocabulary/postData/a2/common-phrasal-verbs": [
		8475,
		2483,
		6807,
		8475
	],
	"./pages/learn/vocabulary/postData/a2/common-phrasal-verbs.js": [
		8475,
		2483,
		6807,
		8475
	],
	"./pages/learn/vocabulary/postData/a2/fitness": [
		3515,
		2483,
		6807,
		3515
	],
	"./pages/learn/vocabulary/postData/a2/fitness.js": [
		3515,
		2483,
		6807,
		3515
	],
	"./pages/learn/vocabulary/postData/a2/giving-directions": [
		6172,
		2483,
		6807,
		6172
	],
	"./pages/learn/vocabulary/postData/a2/giving-directions.js": [
		6172,
		2483,
		6807,
		6172
	],
	"./pages/learn/vocabulary/postData/a2/hobbies-and-free-time": [
		8614,
		2483,
		6807,
		8614
	],
	"./pages/learn/vocabulary/postData/a2/hobbies-and-free-time.js": [
		8614,
		2483,
		6807,
		8614
	],
	"./pages/learn/vocabulary/postData/a2/holidays": [
		1378,
		2483,
		6807,
		1378
	],
	"./pages/learn/vocabulary/postData/a2/holidays.js": [
		1378,
		2483,
		6807,
		1378
	],
	"./pages/learn/vocabulary/postData/a2/in-a-hotel": [
		289,
		2483,
		6807,
		289
	],
	"./pages/learn/vocabulary/postData/a2/in-a-hotel.js": [
		289,
		2483,
		6807,
		289
	],
	"./pages/learn/vocabulary/postData/a2/in-the-hospital": [
		7549,
		2483,
		6807,
		7549
	],
	"./pages/learn/vocabulary/postData/a2/in-the-hospital.js": [
		7549,
		2483,
		6807,
		7549
	],
	"./pages/learn/vocabulary/postData/a2/shopping-in-a-shop": [
		1310,
		2483,
		6807,
		1310
	],
	"./pages/learn/vocabulary/postData/a2/shopping-in-a-shop.js": [
		1310,
		2483,
		6807,
		1310
	],
	"./pages/learn/vocabulary/postData/a2/shopping-places-for-shopping": [
		179,
		2483,
		6807,
		179
	],
	"./pages/learn/vocabulary/postData/a2/shopping-places-for-shopping.js": [
		179,
		2483,
		6807,
		179
	],
	"./pages/learn/vocabulary/postData/a2/taxi": [
		1967,
		2483,
		6807,
		1967
	],
	"./pages/learn/vocabulary/postData/a2/taxi.js": [
		1967,
		2483,
		6807,
		1967
	],
	"./pages/learn/vocabulary/postData/a2/the-weather": [
		1457,
		2483,
		6807,
		1457
	],
	"./pages/learn/vocabulary/postData/a2/the-weather.js": [
		1457,
		2483,
		6807,
		1457
	],
	"./pages/learn/vocabulary/postData/a2/transport": [
		9634,
		2483,
		6807,
		9634
	],
	"./pages/learn/vocabulary/postData/a2/transport.js": [
		9634,
		2483,
		6807,
		9634
	],
	"./pages/learn/vocabulary/postData/b1/animals": [
		7456,
		2483,
		6807,
		7456
	],
	"./pages/learn/vocabulary/postData/b1/animals.js": [
		7456,
		2483,
		6807,
		7456
	],
	"./pages/learn/vocabulary/postData/b1/car": [
		2279,
		2483,
		6807,
		2279
	],
	"./pages/learn/vocabulary/postData/b1/car.js": [
		2279,
		2483,
		6807,
		2279
	],
	"./pages/learn/vocabulary/postData/b1/cooking": [
		3161,
		2483,
		6807,
		3161
	],
	"./pages/learn/vocabulary/postData/b1/cooking.js": [
		3161,
		2483,
		6807,
		3161
	],
	"./pages/learn/vocabulary/postData/b1/education": [
		3819,
		2483,
		6807,
		3819
	],
	"./pages/learn/vocabulary/postData/b1/education.js": [
		3819,
		2483,
		6807,
		3819
	],
	"./pages/learn/vocabulary/postData/b1/food-fruit": [
		7334,
		2483,
		6807,
		7334
	],
	"./pages/learn/vocabulary/postData/b1/food-fruit.js": [
		7334,
		2483,
		6807,
		7334
	],
	"./pages/learn/vocabulary/postData/b1/food-meat-fish-seafood": [
		4314,
		2483,
		6807,
		4314
	],
	"./pages/learn/vocabulary/postData/b1/food-meat-fish-seafood.js": [
		4314,
		2483,
		6807,
		4314
	],
	"./pages/learn/vocabulary/postData/b1/food-vegetables": [
		8966,
		2483,
		6807,
		8966
	],
	"./pages/learn/vocabulary/postData/b1/food-vegetables.js": [
		8966,
		2483,
		6807,
		8966
	],
	"./pages/learn/vocabulary/postData/b1/house": [
		1689,
		2483,
		6807,
		1689
	],
	"./pages/learn/vocabulary/postData/b1/house-electrical-equipment": [
		7065,
		2483,
		6807,
		7065
	],
	"./pages/learn/vocabulary/postData/b1/house-electrical-equipment.js": [
		7065,
		2483,
		6807,
		7065
	],
	"./pages/learn/vocabulary/postData/b1/house.js": [
		1689,
		2483,
		6807,
		1689
	],
	"./pages/learn/vocabulary/postData/b1/irregular-verbs": [
		8003,
		2483,
		6807,
		8003
	],
	"./pages/learn/vocabulary/postData/b1/irregular-verbs.js": [
		8003,
		2483,
		6807,
		8003
	],
	"./pages/learn/vocabulary/postData/b1/money": [
		4641,
		2483,
		6807,
		4641
	],
	"./pages/learn/vocabulary/postData/b1/money.js": [
		4641,
		2483,
		6807,
		4641
	],
	"./pages/learn/vocabulary/postData/b1/news-and-media": [
		5747,
		2483,
		6807,
		5747
	],
	"./pages/learn/vocabulary/postData/b1/news-and-media.js": [
		5747,
		2483,
		6807,
		5747
	],
	"./pages/learn/vocabulary/postData/b1/relationships": [
		8625,
		2483,
		6807,
		8625
	],
	"./pages/learn/vocabulary/postData/b1/relationships.js": [
		8625,
		2483,
		6807,
		8625
	],
	"./pages/learn/vocabulary/postData/b1/sport": [
		8711,
		2483,
		6807,
		8711
	],
	"./pages/learn/vocabulary/postData/b1/sport.js": [
		8711,
		2483,
		6807,
		8711
	],
	"./pages/learn/vocabulary/postData/b1/texture": [
		7082,
		2483,
		6807,
		7082
	],
	"./pages/learn/vocabulary/postData/b1/texture.js": [
		7082,
		2483,
		6807,
		7082
	],
	"./pages/learn/vocabulary/postData/b1/work": [
		7192,
		2483,
		6807,
		7192
	],
	"./pages/learn/vocabulary/postData/b1/work.js": [
		7192,
		2483,
		6807,
		7192
	],
	"./pages/learn/vocabulary/postData/b2/air-travel": [
		2065,
		2483,
		6807,
		2065
	],
	"./pages/learn/vocabulary/postData/b2/air-travel.js": [
		2065,
		2483,
		6807,
		2065
	],
	"./pages/learn/vocabulary/postData/b2/business": [
		1708,
		2483,
		6807,
		1708
	],
	"./pages/learn/vocabulary/postData/b2/business.js": [
		1708,
		2483,
		6807,
		1708
	],
	"./pages/learn/vocabulary/postData/b2/car-travel": [
		9811,
		2483,
		6807,
		9811
	],
	"./pages/learn/vocabulary/postData/b2/car-travel.js": [
		9811,
		2483,
		6807,
		9811
	],
	"./pages/learn/vocabulary/postData/b2/character-n-behavior": [
		7047,
		2483,
		6807,
		7047
	],
	"./pages/learn/vocabulary/postData/b2/character-n-behavior.js": [
		7047,
		2483,
		6807,
		7047
	],
	"./pages/learn/vocabulary/postData/b2/crime-and-punishment": [
		7918,
		2483,
		6807,
		7918
	],
	"./pages/learn/vocabulary/postData/b2/crime-and-punishment.js": [
		7918,
		2483,
		6807,
		7918
	],
	"./pages/learn/vocabulary/postData/b2/describing-books": [
		7671,
		2483,
		6807,
		7671
	],
	"./pages/learn/vocabulary/postData/b2/describing-books.js": [
		7671,
		2483,
		6807,
		7671
	],
	"./pages/learn/vocabulary/postData/b2/describing-peoples-demeanor": [
		3241,
		2483,
		6807,
		3241
	],
	"./pages/learn/vocabulary/postData/b2/describing-peoples-demeanor.js": [
		3241,
		2483,
		6807,
		3241
	],
	"./pages/learn/vocabulary/postData/b2/describing-peoples-expression": [
		8904,
		2483,
		6807,
		8904
	],
	"./pages/learn/vocabulary/postData/b2/describing-peoples-expression.js": [
		8904,
		2483,
		6807,
		8904
	],
	"./pages/learn/vocabulary/postData/b2/describing-peoples-general-features": [
		8662,
		2483,
		6807,
		8662
	],
	"./pages/learn/vocabulary/postData/b2/describing-peoples-general-features.js": [
		8662,
		2483,
		6807,
		8662
	],
	"./pages/learn/vocabulary/postData/b2/fears-and-phobias": [
		4182,
		2483,
		6807,
		4182
	],
	"./pages/learn/vocabulary/postData/b2/fears-and-phobias.js": [
		4182,
		2483,
		6807,
		4182
	],
	"./pages/learn/vocabulary/postData/b2/feelings-and-emotions": [
		2578,
		2483,
		6807,
		2578
	],
	"./pages/learn/vocabulary/postData/b2/feelings-and-emotions.js": [
		2578,
		2483,
		6807,
		2578
	],
	"./pages/learn/vocabulary/postData/b2/health-problems-and-injuries": [
		9761,
		2483,
		6807,
		9761
	],
	"./pages/learn/vocabulary/postData/b2/health-problems-and-injuries.js": [
		9761,
		2483,
		6807,
		9761
	],
	"./pages/learn/vocabulary/postData/b2/law-and-crime": [
		8764,
		2483,
		6807,
		6383
	],
	"./pages/learn/vocabulary/postData/b2/law-and-crime.js": [
		8764,
		2483,
		6807,
		6383
	],
	"./pages/learn/vocabulary/postData/b2/technology": [
		2888,
		2483,
		6807,
		2888
	],
	"./pages/learn/vocabulary/postData/b2/technology.js": [
		2888,
		2483,
		6807,
		2888
	],
	"./pages/learn/vocabulary/postData/b2/train-travel": [
		8219,
		2483,
		6807,
		8219
	],
	"./pages/learn/vocabulary/postData/b2/train-travel.js": [
		8219,
		2483,
		6807,
		8219
	],
	"./pages/learn/vocabulary/postData/b2/types-of-crime-and-offenders": [
		691,
		2483,
		6807,
		691
	],
	"./pages/learn/vocabulary/postData/b2/types-of-crime-and-offenders.js": [
		691,
		2483,
		6807,
		691
	],
	"./pages/learn/vocabulary/postData/b2a/cars-roads-traffic": [
		3533,
		2483,
		6807,
		5914
	],
	"./pages/learn/vocabulary/postData/b2a/cars-roads-traffic.js": [
		3533,
		2483,
		6807,
		5914
	],
	"./pages/learn/vocabulary/postData/b2a/economics-and-finance": [
		9246,
		2483,
		6807,
		9246
	],
	"./pages/learn/vocabulary/postData/b2a/economics-and-finance.js": [
		9246,
		2483,
		6807,
		9246
	],
	"./pages/learn/vocabulary/postData/b2a/job-search-and-hiring": [
		6011,
		2483,
		6807,
		6011
	],
	"./pages/learn/vocabulary/postData/b2a/job-search-and-hiring.js": [
		6011,
		2483,
		6807,
		6011
	],
	"./pages/learn/vocabulary/postData/b2a/music-vocabulary": [
		8485,
		2483,
		6807,
		8485
	],
	"./pages/learn/vocabulary/postData/b2a/music-vocabulary.js": [
		8485,
		2483,
		6807,
		8485
	],
	"./pages/learn/vocabulary/postData/b2a/tv-and-film-genres": [
		6961,
		2483,
		6807,
		6961
	],
	"./pages/learn/vocabulary/postData/b2a/tv-and-film-genres.js": [
		6961,
		2483,
		6807,
		6961
	],
	"./pages/learn/vocabulary/postData/b2a/workplace-dynamics": [
		818,
		2483,
		6807,
		818
	],
	"./pages/learn/vocabulary/postData/b2a/workplace-dynamics.js": [
		818,
		2483,
		6807,
		818
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/admission-or-realization": [
		2658,
		2483,
		6807,
		2658
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/admission-or-realization.js": [
		2658,
		2483,
		6807,
		2658
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/communication-or-expression": [
		3563,
		2483,
		6807,
		3563
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/communication-or-expression.js": [
		3563,
		2483,
		6807,
		3563
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/moving-verb": [
		6900,
		2483,
		6807,
		6900
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/moving-verb.js": [
		6900,
		2483,
		6807,
		6900
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/non-action-verbs": [
		6065,
		2483,
		6807,
		6065
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/non-action-verbs.js": [
		6065,
		2483,
		6807,
		6065
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/very-beautiful": [
		7684,
		2483,
		6807,
		7684
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/very-beautiful.js": [
		7684,
		2483,
		6807,
		7684
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/very-tasty": [
		8556,
		2483,
		6807,
		8556
	],
	"./pages/learn/vocabulary/postData/more-vocabulary/very-tasty.js": [
		8556,
		2483,
		6807,
		8556
	],
	"./pages/main/dashboard": [
		7125,
		7125
	],
	"./pages/main/dashboard/": [
		7125,
		7125
	],
	"./pages/main/dashboard/index": [
		7125,
		7125
	],
	"./pages/main/dashboard/index.js": [
		7125,
		7125
	],
	"./pages/main/dashboard/listOfTopics": [
		1139,
		1139
	],
	"./pages/main/dashboard/listOfTopics/": [
		1139,
		1139
	],
	"./pages/main/dashboard/listOfTopics/index": [
		1139,
		1139
	],
	"./pages/main/dashboard/listOfTopics/index.js": [
		1139,
		1139
	],
	"./pages/main/dashboard/statBlock": [
		8853,
		8853
	],
	"./pages/main/dashboard/statBlock/": [
		8853,
		8853
	],
	"./pages/main/dashboard/statBlock/index": [
		8853,
		8853
	],
	"./pages/main/dashboard/statBlock/index.js": [
		8853,
		8853
	],
	"./pages/main/introduce": [
		1632,
		6807,
		1632
	],
	"./pages/main/introduce/": [
		1632,
		6807,
		1632
	],
	"./pages/main/introduce/index": [
		1632,
		6807,
		1632
	],
	"./pages/main/introduce/index.js": [
		1632,
		6807,
		1632
	],
	"./pages/main/main": [
		4669,
		6807,
		116,
		4669
	],
	"./pages/main/main.js": [
		4669,
		6807,
		116,
		4669
	],
	"./pages/prepareSentences": [
		3908,
		2483,
		6807,
		1222,
		2724,
		116,
		2115,
		6806,
		3908
	],
	"./pages/prepareSentences/": [
		3908,
		2483,
		6807,
		1222,
		2724,
		116,
		2115,
		6806,
		3908
	],
	"./pages/prepareSentences/actionButtonsBottom": [
		8109,
		2724,
		4762
	],
	"./pages/prepareSentences/actionButtonsBottom/": [
		8109,
		2724,
		4762
	],
	"./pages/prepareSentences/actionButtonsBottom/index": [
		8109,
		2724,
		4762
	],
	"./pages/prepareSentences/actionButtonsBottom/index.jsx": [
		8109,
		2724,
		4762
	],
	"./pages/prepareSentences/actionButtonsUp": [
		9847,
		9847
	],
	"./pages/prepareSentences/actionButtonsUp/": [
		9847,
		9847
	],
	"./pages/prepareSentences/actionButtonsUp/index": [
		9847,
		9847
	],
	"./pages/prepareSentences/actionButtonsUp/index.jsx": [
		9847,
		9847
	],
	"./pages/prepareSentences/header/header": [
		265,
		2115,
		2406
	],
	"./pages/prepareSentences/header/header.jsx": [
		265,
		2115,
		2406
	],
	"./pages/prepareSentences/index": [
		3908,
		2483,
		6807,
		1222,
		2724,
		116,
		2115,
		6806,
		3908
	],
	"./pages/prepareSentences/index.jsx": [
		3908,
		2483,
		6807,
		1222,
		2724,
		116,
		2115,
		6806,
		3908
	],
	"./pages/prepareSentences/listOfSentences": [
		9826,
		2483,
		1222,
		2724,
		116,
		9826
	],
	"./pages/prepareSentences/listOfSentences/": [
		9826,
		2483,
		1222,
		2724,
		116,
		9826
	],
	"./pages/prepareSentences/listOfSentences/index": [
		9826,
		2483,
		1222,
		2724,
		116,
		9826
	],
	"./pages/prepareSentences/listOfSentences/index.jsx": [
		9826,
		2483,
		1222,
		2724,
		116,
		9826
	],
	"./pages/prepareSentences/listOfTopics": [
		5924,
		5924
	],
	"./pages/prepareSentences/listOfTopics/": [
		5924,
		5924
	],
	"./pages/prepareSentences/listOfTopics/index": [
		5924,
		5924
	],
	"./pages/prepareSentences/listOfTopics/index.jsx": [
		5924,
		5924
	],
	"./pages/prepareSentences/topicTips": [
		9362,
		2724,
		6806,
		1885
	],
	"./pages/prepareSentences/topicTips/": [
		9362,
		2724,
		6806,
		1885
	],
	"./pages/prepareSentences/topicTips/index": [
		9362,
		2724,
		6806,
		1885
	],
	"./pages/prepareSentences/topicTips/index.jsx": [
		9362,
		2724,
		6806,
		1885
	],
	"./pages/reader/itemText/itemTextIndex": [
		4501,
		2483,
		1222,
		2216,
		4501
	],
	"./pages/reader/itemText/itemTextIndex.js": [
		4501,
		2483,
		1222,
		2216,
		4501
	],
	"./pages/reader/itemText/page/page": [
		9326,
		2483,
		9326
	],
	"./pages/reader/itemText/page/page.js": [
		9326,
		2483,
		9326
	],
	"./pages/reader/itemText/pagination/pagination": [
		9652,
		2483,
		9652
	],
	"./pages/reader/itemText/pagination/pagination.js": [
		9652,
		2483,
		9652
	],
	"./pages/reader/itemText/settings/settings": [
		2498,
		2498
	],
	"./pages/reader/itemText/settings/settings.js": [
		2498,
		2498
	],
	"./pages/reader/listOfTexts/list/list": [
		497,
		2483,
		497
	],
	"./pages/reader/listOfTexts/list/list.js": [
		497,
		2483,
		497
	],
	"./pages/reader/listOfTexts/listOfTextsIndex": [
		1635,
		2483,
		1222,
		2216,
		1635
	],
	"./pages/reader/listOfTexts/listOfTextsIndex.js": [
		1635,
		2483,
		1222,
		2216,
		1635
	],
	"./pages/reader/listOfTexts/uploadFile/uploadFile": [
		8491,
		1222,
		8491
	],
	"./pages/reader/listOfTexts/uploadFile/uploadFile.js": [
		8491,
		1222,
		8491
	],
	"./wrapper/Index": [
		3505
	],
	"./wrapper/Index.js": [
		3505
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7227;
module.exports = webpackAsyncContext;